import queryString from 'qs';

const getHostScheduleRequest = (queryParams) => {
  const queries = {
    startedAt: `gte.${queryParams?.startDate}`,
    endedAt: `lte.${queryParams?.endDate}`,
  };

  if (queryParams?.sort) queries.sort = queryParams.sort;
  if (queryParams?.search) queries.search = queryParams.search;
  if (queryParams?.page) queries.page = queryParams.page;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getHostScheduleRequest;
